<template>
  <div class="home-page">
    <nav-bar/>
    <search-bar/>
    <div class="nav_box" v-show="arr.includes($route.name)">
      <div class="home-nav-bar fr ac jc">
        <router-link
            class="nav_item fr ac jc fz18 cursor"
            v-for="i in nav"
            :to="i.to"
            :key="i.to"
        >
          <span :class="{blue:$route.path.indexOf(i.to) !== -1}">{{ i.name }}</span>
          <div class="line" v-show="$route.path.indexOf(i.to) !== -1"/>
        </router-link>
      </div>
    </div>
    <router-view/>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  props: {},
  data() {
    return {
      nav: [
        {
          name: "首页",
          to: "index"
        },
        {
          name: "商城",
          to: "mall"
        },
        {
          name: "知识库",
          to: "info"
        },
        {
          name: "联系我们",
          to: "contact"
        }
      ],
      arr: ["homeindex", "homemall", "homeminfo", "homemcontact"]
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {},
  methods: {},
  components: {
    "nav-bar": NavBar,
    "search-bar": SearchBar,
    "footer-bar": FooterBar
  }
};
</script>

<style scoped lang="scss">
.home-page {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;


  .nav_box {
    width: 100%;
    background-color: #fff;

    .home-nav-bar {
      margin: 0 auto;
      width: 100%;
      height: 60px;

      .nav_item {
        width: 160px;
        height: 100%;
        position: relative;

        .line {
          width: 50%;
          height: 2px;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 10%;
          margin: auto;
          background-color: #458ef6;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/index.vue